import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CategoryTipJar.module.css';

const CategoryTipJar = (props) => {
  const [isChanged, setIsChanged] = useState(false);

  const { low, med, high } = props;
  const [tipJarPrice, setTipJarPrice] = useState({
    low,
    med,
    high,
  });
  // const [tipJarPrice, setTipJarPrice] = useState([]);

  const handleChange = (e) => {
    setIsChanged(true);
    setTipJarPrice({
      ...tipJarPrice,
      [e.target.name]: parseFloat(e.target.value),
    });
  };

  const handleBlur = () => {
    if (isChanged) {
      props.onTipJarChange(tipJarPrice);
    } else {
      console.log('change price to submit!');
    }
  };

  const { className } = props;
  const classes = `${className} ${styles.price}`;
  return (
    <>
      <td className={classes}>
        <input
          type="number"
          name="low"
          min="0"
          step="0.01"
          onChange={handleChange}
          onBlur={handleBlur}
          value={tipJarPrice.low}
          // defaultValue={props.low}
          className={classes}
        />
      </td>
      <td className={classes}>
        <input
          type="number"
          name="med"
          min="0"
          step="0.01"
          onChange={handleChange}
          onBlur={handleBlur}
          value={tipJarPrice.med}
          // defaultValue={props.med}
          className={classes}
        />
      </td>
      <td className={classes}>
        <input
          type="number"
          name="high"
          min="0"
          step="0.01"
          onChange={handleChange}
          onBlur={handleBlur}
          value={tipJarPrice.high}
          // defaultValue={props.high}
          className={classes}
        />
      </td>
    </>
  );
};

CategoryTipJar.propTypes = {
  low: PropTypes.node.isRequired,
  med: PropTypes.node.isRequired,
  high: PropTypes.node.isRequired,
  className: PropTypes.node.isRequired,
  onTipJarChange: PropTypes.node.isRequired,
};

export default CategoryTipJar;
